import { Divider, Text } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import { NachversandAppointmentDetails } from '../../waiting-phase/NachversandAppointmentDetails';
import { bodyTextProps, Part2Appointment } from '../utils';

// The booked call and what to have ready for it, used in the "Versand" tab and the home banner.
export const Part2AppointmentDetails = ({
  appointment,
  withBringAlong = true,
}: {
  appointment: Part2Appointment;
  withBringAlong?: boolean;
}) => {
  const { t } = useTranslation('versand');

  return (
    <>
      <NachversandAppointmentDetails
        appointment={{
          id: appointment.id,
          startTime: appointment.startTime,
          endTime: appointment.endTime,
          location: appointment.joinUrl,
        }}
        withTrailingDivider={false}
      />
      {/* no margins of its own: the surrounding column's gap spaces it */}
      {withBringAlong && (
        <>
          <Divider />
          <Text {...bodyTextProps}>{t('BringAlong')}</Text>
        </>
      )}
    </>
  );
};
